//Prachi T - 16-11-2023 - BT-110050 - Breeze- Settings Preferences - Start
import { getSegmentWiseVersion, uploadProfilePicture } from "../../apis/nontransactional";
import { _updateUserPreference } from "../../controllers/settings";
//Prachi T - 16-11-2023 - BT-110050 - Breeze- Settings Preferences - End
import { HEADERS } from "../actionTypes";
import config from '../../config.json';
import { _handleProfilePic } from "../../controllers/auth";

export const notificationList = (payload) => {
    return { type: HEADERS.GET_NOTIFICATIONS, payload: {} };
};

export const userInformation = (payload) => {
    return { type: HEADERS.GET_USERINFORMATION, payload: {} };
};


/* Shuaib.P  SAT-BT-109047 Start  */
//Prachi T - 16-11-2023 - BT-110050 - Breeze- Settings Preferences - Start
export const uploadUserProfilePicture = (payload) => async (dispatch) => {
    try {
        const { formData, currentPreference } = payload;
        const objResp = await uploadProfilePicture(formData);
        let objRes1;
        if (objResp?.status && objResp?.data) {
            dispatch(uploadUserProfilePictureSuccess(objResp?.data));
            const preferencePayload = {
                sProfilePicPath: `${config.Wave.Cloudfront_S3_URL}${objResp?.data?.result?.filePath}?${(new Date().getTime()).toString()}`,
            };
            objRes1 = await dispatch(updateUserPreference(currentPreference, preferencePayload));
        } else {
            dispatch(uploadUserProfilePictureFailure([]));
        }
        return Promise.resolve({ objRes1: objResp.data, objRes2: objRes1 });
    } catch (error) {
        console.log(error);
        dispatch(uploadUserProfilePictureFailure([]));
        return Promise.reject(error);
    }
};
//Prachi T - 16-11-2023 - BT-110050 - Breeze- Settings Preferences - End
/* Shuaib.P  SAT-BT-109047 End  */

export const uploadUserProfilePictureSuccess = (payload) => {
    return { type: HEADERS.UPLOAD_USER_PROFILE_PICTURE_SUCCESS, payload };
};

export const uploadUserProfilePictureFailure = (payload) => {
    return { type: HEADERS.UPLOAD_USER_PROFILE_PICTURE_FAILURE, payload };
};

export const updateUserPreference = (currentPreference, payload) => async (dispatch) => {
    try {
        //Prachi T - 16-11-2023 - BT-110050 - Breeze- Settings Preferences - Start
        const objResp = await _updateUserPreference(currentPreference, payload);
        /* Deepti B. 110050: Not updating redux on bad request status */
        if (objResp?.data) {
            dispatch(userPreferenceSuccess([objResp?.data]));
        } else {
            dispatch(userPreferenceFailure());
        }
        return Promise.resolve(objResp?.data);
        //Prachi T - 16-11-2023 - BT-110050 - Breeze- Settings Preferences - En
    } catch (error) {
        console.log(error);
        return Promise.resolve(objResp?.data);
        dispatch(userPreferenceFailure({}));
    }
};

export const userPreferenceSuccess = (payload) => {
    // {/* Mahesh S : 09-11-2023 : BT-97226 Subsequent Login – moving to controllers – Start */ }
    _handleProfilePic(payload);
    // {/* Mahesh S : 09-11-2023 : BT-97226 Subsequent Login – moving to controllers – End */ }
    return { type: HEADERS.GET_USER_PREFERENCE_SUCCESS, payload };
};

export const resetUserPreference = () => {
    return { type: HEADERS.RESET_USER_PREFERENCE };
};

export const userPreferenceFailure = (payload) => {
    return { type: HEADERS.GET_USER_PREFERENCE_FAILURE, payload };
};

//Prachi T BT-110050 Settings and Preferences - Start
export const updateTenantUserPreference = (payload) => {
    return { type: HEADERS?.UPDATE_TENANT_USER_PREFERENCE, payload };
};
//Prachi T BT-110050 Settings and Preferences - End

//Deepti B. BT-110050 Settings and Preferences - Start
export const tempUserPreference = (payload) => {
    return { type: HEADERS?.GET_USER_PREFERENCE_DATA, payload };
};
//Deepti B. BT-110050 Settings and Preferences - End

/* BREEZE-4265 : Ravi R : 05-03-2025: Display segment wise version number - Start */
export const segmentWiseVersion=()=>async (dispatch)=>{
    try {        
        const objResp = await getSegmentWiseVersion();
        dispatch(segmentWiseVersionSuccess(objResp.data));
        return Promise.resolve(objResp);
    } catch (error) {
        console.error(error.message);
        if (error?.response?.data) {
            dispatch(segmentWiseVersionFailure(error?.response?.data));
        } else {
            dispatch(segmentWiseVersionFailure({}));
        }
        return Promise.reject(error);
    }
}
export const segmentWiseVersionSuccess=(payload)=>{
    return { type: HEADERS.SEGMENT_WISE_VERSION_SUCCESS, payload };
}
export const segmentWiseVersionFailure=(payload)=>{
    return { type: HEADERS.SEGMENT_WISE_VERSION_FAILURE, payload };
}
/* BREEZE-4265 : Ravi R : 05-03-2025: Display segment wise version number -End */